const processTourDates = (tourStartDate: string, tourEndDate: string): string => {
  if (!tourStartDate || !tourEndDate) return "";

  const [startMonthDay, startYear] = tourStartDate.split(", ");
  const [endMonthDay, endYear] = tourEndDate.split(", ");

  if (startYear === endYear) {
    return `${startMonthDay} - ${endMonthDay}, ${startYear}`;
  }

  return `${startMonthDay}, ${startYear} - ${endMonthDay}, ${endYear}`;
};

export default processTourDates;
